<template>
  <div class>
    <el-row>
      <el-col :span="4" style="flex:1;padding: 10px;padding-top:0px;">
        <div style="height:80vh;overflow-y:auto;">
          <DeptSelect @departmentSelect="deptSelectMethod" :default-expand-all="false"></DeptSelect>
        </div>
      </el-col>

      <el-col
        :span="5"
        style="flex:1;display: flex;flex-direction: column;padding: 10px;padding-top:0px"
      >
        <!-- 讨论后决定还是不使用el-tree，使用无边框的el-table -->
        <el-input v-model="search" placeholder="请输入姓名或拼音" prefix-icon="el-icon-search" clearable size="small" @input="inputsr"></el-input>

        <div>
          <el-table
            :data="tables"
            size="mini"
            :show-header="sh"
            @row-click="renYuan"
            style="height:80vh;overflow-y:auto;"
            highlight-current-row
          >
            <!-- <el-table-column hidden="hidden" prop="id" label></el-table-column> -->
            <el-table-column width="50">
              <el-avatar size="small" icon="el-icon-user-solid"></el-avatar>
            </el-table-column>
            <el-table-column prop="realname"></el-table-column>
            <el-table-column prop="letter" width="70">
              <template slot-scope="scope">
                <el-tag class="ziti">{{(scope.row.letter[0]).toUpperCase()}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>

      <el-col :span="15" style="flex:5;padding: 10px;">
        <div style="display: flex;">
          <div style="flex:1">
            <div id="div1">
              <img src="../../assets/timg1.jpg" alt="默认头像" width="100%" />
            </div>
          </div>
          <div style="flex:5;padding-left:30px;">
            <table style="height:100%">
              <tr>
                <td style="vertical-align: middle;height:100%">
                  <span class="cu">{{tableData.name}}</span>
                  <br/><br/>
                  <span class="cu_txl">{{tableData.bm}}</span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cu_txl">通讯录</span>
          </div>
          <div>
            <el-row>
              <el-col :span="5">
                <div style="float:right;">
                  <span class="cu_txl">移动电话：</span>
                </div>
              </el-col>
              <el-col :span="19">
                <span class="cu_txl">{{tableData.mobile}}</span>
              </el-col>
            </el-row>
            <el-divider class="divider"></el-divider>
            <el-row>
              <el-col :span="5">
                <div style="float:right;">
                  <span class="cu_txl">座机：</span>
                </div>
              </el-col>
              <el-col :span="19">
                <span class="cu_txl">{{tableData.tel}}</span>
              </el-col>
            </el-row>
            <el-divider class="divider"></el-divider>
            <el-row>
              <el-col :span="5">
                <div style="float:right;">
                  <span class="cu_txl">邮箱：</span>
                </div>
              </el-col>
              <el-col :span="19">
                <span class="cu_txl">{{tableData.email}}</span>
              </el-col>
            </el-row>
            <el-divider class="divider"></el-divider>
            <el-row>
              <el-col :span="5">
                <div style="float:right;">
                  <span class="cu_txl">备注：</span>
                </div>
              </el-col>
              <el-col :span="19">
                <span class="cu_txl">{{tableData.remark}}</span>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <div style="text-align:center;padding:20px">
          <el-button v-if="buttonShow2" icon="el-icon-circle-plus-outline" type="primary" size="small" @click="add()">新增</el-button>
          <el-button v-if="buttonShow1" icon="el-icon-edit" type="primary" size="small" @click="edit()">编辑</el-button>
          <el-button v-if="buttonShow1" icon="el-icon-delete" type="primary" size="small" @click="deleteD()">删除</el-button>
        </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="addVisible" :fullscreen="false" :close-on-click-modal="false" width="950px">
      <Puw :abData="abData" @closeAffressBook="closeAffressBook"></Puw>
    </el-dialog>
  </div>
</template>


<script>
import DeptSelect from "@/components/common/deptMenu.vue";
import Puw from "@/components/addressBook/thePopUpWindow.vue";

export default {
  components: {
    DeptSelect,
    Puw
  },
  data() {
    return {
      intC: null,//初始化数据使用
      bmData: [{}],//保存部门数据
      personDataAll: [{}],//保存外部和内部的所有数据
      wbtxlwzid:'',//外部通讯录位置（点击）id
      avatarLink: "src/assets/1.jpg",
      tableData: {
        name: "",
        mobile: "",
        tel: "",
        email: "",
        remark: "",
        userId: "",
        id: "",
        isPrive: ""
      },
      addVisible: false,
      dialogTitle: "",
      abData: {
        name: "",
        mobile: "",
        tel: "",
        email: "",
        remark: "",
        isPrive: ""
      },
      buttonShow1: false, //只有外部通讯录可以进行按钮操作。
      buttonShow2: false, //只有外部通讯录可以进行按钮操作。
      data: [],
      sh: false,
      search: "",
      defaultProps: {
        children: "children",
        label: "label"
      },
      personData: [{}], //保存用户数据(系统内)
      personData2: [{}] //保存用户数据（系统外）
    };
  },
  methods: {
    //点击部门显示人员。
    deptSelectMethod(data) {
      this.wbtxlwzid = data.id;
      if(data.id < 0){
        // 点击系统外人员
        this.hnclick(data);
      }else{
        // 点击正常的部门树
        this.buttonShow1 = false;
        this.buttonShow2 = false;
        var id = data.id.toString();
        var personData = this.personData;
        var toData = [];

        //点击部门树，清空详细信息的显示。//修改，根据目前选中的人进行判断。
        if (this.tableData.bm == "我的" || this.tableData.bm == "共享") {
          this.tableData = {};
        }

        //同时隐藏编辑和删除按钮。
        this.buttonShow1 = false;

        for (let i = 0; i < personData.length; i++) {
          let DEPT_IDS = personData[i]["deptIds"];
          let arr = DEPT_IDS.split(",");
          if (arr.indexOf(id) > -1) {
            toData.push(personData[i]);
          }
        }
        this.data = toData;
      }

    },
    closeAffressBook(value) {
      this.addVisible = false;
      this.isSave = false;
      if (value) {
        this.tableData.name = value.name;
        this.tableData.mobile = value.mobile;
        this.tableData.tel = value.tel;
        this.tableData.email = value.email;
        this.tableData.remark = value.remark;
        this.tableData.userId = value.userId;
        this.tableData.id = value.id;
        this.tableData.isPrive = value.isPrive;

        this.buttonShow1 = true;
        this.query();
      }
    },
    edit() {
      //获取用户信息,非创建人不能进行删除操作。
      let userInfo = this.CommonUtil.getUserInfo();
      if (this.tableData["userId"] != userInfo["userId"]) {
        this.$message({
          message: "您不是创建人，不能进行修改！",
          type: "warning"
        });
        return;
      }
      this.abData = {
        name: "",
        mobile: "",
        tel: "",
        email: "",
        remark: "",
        isPrive: ""
      };
      this.abData["userId"] = this.tableData["userId"];
      this.abData["id"] = this.tableData["id"];
      this.abData["name"] = this.tableData["name"];
      this.abData["mobile"] = this.tableData["mobile"];
      this.abData["tel"] = this.tableData["tel"];
      this.abData["email"] = this.tableData["email"];
      this.abData["remark"] = this.tableData["remark"];
      this.abData["isPrive"] = this.tableData["isPrive"] ? this.tableData["isPrive"] != "0" ? "1" : this.tableData["isPrive"] : "0";
      this.dialogTitle = "编辑外部通信录";
      this.addVisible = true;
    },
    add() {
      this.abData = {};
      this.dialogTitle = "新增外部通信录";
      this.addVisible = true;
    },
    deleteD() {
      //获取用户信息,非创建人不能进行删除操作。
      let userInfo = this.CommonUtil.getUserInfo();
      if (this.tableData["userId"] != userInfo["userId"]) {
        this.$message({
          message: "您不是创建人，不能进行删除操作。",
          type: "warning"
        });
        return;
      }

      let ttmm = this;
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let temp = {};
        temp["userId"] = this.tableData["userId"];
        temp["id"] = this.tableData["id"];
        this.$axios.post("/address/delete", temp).then(response => {
          this.query();
          ttmm.tableData = {};
          if (response.code == "0000") {
            this.$message({
              message: response.message,
              type: "success"
            });
          } else {
            this.$message({
              message: response.message,
              type: "warning"
            });
          }
        });
      });
    },
    hnclick(data) {
      var id = data.id.toString();
      var personData = this.personData2;

      //保存 外部通讯录位置（点击）id
      this.wbtxlwzid = id;

      //点击外部通信录，要显示新增按钮。
      this.buttonShow2 = true;

      //点击部门树，清空详细信息的显示。//修改，根据目前选中的人进行判断。
      if (this.tableData.bm != "我的" && this.tableData.bm != "共享") {
        this.tableData = {};
      }
      //同时隐藏编辑和删除按钮。
      //this.buttonShow1 = false;

      //处理数据，方便显示
      for (let x of personData) {
        x["realname"] = x["name"];
      }

      var toData = [];
      if (id == "-1") {
        //总目录，显示
        toData = personData;
      } else if (id == "-3") {
        for (let x of personData) {
          if (x["isPrive"] == "0") {
            toData.push(x);
          }
        }
      } else if (id == "-2") {
        for (let x of personData) {
          if (x["isPrive"] != "0") {
            toData.push(x);
          }
        }
      }
      this.data = toData;
    },
    renderContent(h, { node, data, store }) {
      if (data.id == "1") {
        return (
          <span class="custom-tree-node">
            <i class="el-icon-phone-outline"></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <i class="el-icon-office-building"></i>
            <span style="margin-left:5px;">{node.label}</span>
          </span>
        );
      }
    },
    //点击人员显示人员的详细信息。
    renYuan: function(row, column, event) {
      this.tableData = {};
      this.buttonShow1 = false;
      this.buttonShow2 = false;
      this.tableData.userId = row["userId"] ? row["userId"] : null;
      this.tableData.id = row["id"];
      this.tableData.name = row["realname"];
      this.tableData.mobile = row["mobile"];
      this.tableData.tel = row["tel"];
      this.tableData.email = row["email"];
      this.tableData.remark = row["remark"] ? row["remark"] : "";
      this.tableData.isPrive = row["isPrive"] ? row["isPrive"] : "";

      //对部门名称赋值
      this.tableData.bm = '';
      if(!row['deptId']){
        if((row["isPrive"] ? row["isPrive"] : '0') == '0'){
          this.tableData.bm = '共享';
        } else {
          this.tableData.bm = '我的';
        }
      } else {
        let bm = row['deptId'];
        for(let x of this.bmData){
          if(x.id == bm){
            this.tableData.bm = x.name;
            continue;
          }
        }
        if(!this.tableData.bm){
          this.tableData.bm = '不明';
        }
      }

      if (row["name"]) {
        //如果数据中包含name项，那么数据是外部通信录
        this.buttonShow1 = true;
        this.buttonShow2 = true;
      }
    },
    //排序
    PX: function() {
      let a = this.personData;
      let b = this.personData2;
      let tempA = [];
      let tempB = [];

      let tempAll = [];//临时保存所有的排序数据;

      let words = []; //保存大写的26个字母
      for (let i = 0; i < 26; i++) {
        let word = String.fromCharCode(65 + i);
        words.push(word);
        for (let x of a) {
          let letter = x["letter"].trim().split("")[0].toUpperCase();
          if (letter == word) {
            tempA.push(x);
            tempAll.push(x);
          }
        }
        for (let x of b) {
          let letter = x["letter"].trim().split("")[0].toUpperCase();
          if (letter == word) {
            tempB.push(x);
            tempAll.push(x);
          }
        }
      }

      //补充，将姓名拼音首字母不是字母的数据补充到最后。
      for (let x of a) {
        let letter = x["letter"].trim().split("")[0].toUpperCase();
        if (words.indexOf(letter) == -1) {
          tempA.push(x);
          tempAll.push(x);
        }
      }
      for (let x of b) {
        let letter = x["letter"].trim().split("")[0].toUpperCase();
        if (words.indexOf(letter) == -1) {
          tempB.push(x);
          tempAll.push(x);
        }
      }

      this.personData = tempA;
      this.personData2 = tempB;

      this.personDataAll = tempAll;
    },
    //过滤人员框
    inputsr(value) {},
    query() {
      var temp = this;
      temp.$axios
        .get("/address/personData")
        .then(function(response) {
          temp.personData = response.data.data;
          temp.personData2 = response.data.data2;

          //对列表进行排序，实现人员列表的的排序
          // temp.PX();
          temp.deptSelectMethod({id:1})
          //触发外部通讯录点击事件
          // temp.deptSelectMethod({ id: temp.wbtxlwzid ? temp.wbtxlwzid : '-1'});
          //清空详细信息显示栏
          //temp.tableData = {};
          //隐藏不应显示的按钮/根据要求现在不隐藏。
          if (!temp.tableData.id) {
            temp.buttonShow1 = false;
          }
        });
    },
    //初始化的时候将所有数据展示出来
    zsAll: function(){
      if(this.personDataAll && this.personDataAll.length > 1){
        this.data = this.personDataAll;
        window.clearInterval(this.intC);
      }
    }
  },
  created: function() {
    this.query();
    //获取部门数据
    var temp = this;
    temp.$axios
      .get("/address/bmData")
      .then(function(response) {
        temp.bmData = response.data;
        // temp.zsAll
      });

    //初次进入页面，需要显示所有数据
    this.intC = self.setInterval(this.zsAll,100);
  },
  computed: {
    tables: function() {
      var search = this.search;
      if (search) {
        this.personDataAll = this.personData.concat(this.personData2);
        return this.personDataAll.filter(function(dataNews) {
          return Object.keys(dataNews).some(function(key) {
            if (["realname", "letter"].indexOf(key) == -1) {
              return false;
            } else {
              return (
                String(dataNews[key])
                  .toLowerCase()
                  .indexOf(search.toLowerCase()) > -1
              );
            }
          });
        });
      }
      return this.data;
    }
  }
};
</script>


<style scoped>
#div1 {
  margin: 10px auto;
}
#div1 img {
  border-radius: 50%;
}
.cu {
  font-weight: 600;
  font-size: 25px;
  font-family: Cursive;
}
.cu_txl {
  font-weight: 500;
  font-size: 19px;
  font-family: Cursive;
}
.divider {
  margin-top: 12px;
  margin-right: 0px;
  margin-bottom: 12px;
  margin-left: 0px;
}
.el-card__body {
  padding: 12px;
}
.ziti {
  font-family: Monospace;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

:hover::-webkit-scrollbar-thumb {
  background: hsla(0, 0%, 53%, 0.4);
}

:hover::-webkit-scrollbar-track {
  background: hsla(0, 0%, 53%, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/addressBook/list.vue